import React from 'react';

export const SearchDeskTop = (props)=> (
	<div  className="chatLanding-Search-XA3-body">

    <svg id="searchWrapperContainer"  width="32px" height="22px" viewBox="0 0 32 22" className="icon_xa_fill" aria-labelledby="XfinityTitle" role="img" version="1.1" xmlns="http://www.w3.org/2000/svg" focusable="false">
		<title id="XfinityChatIcon" />
		<defs>
		<filter id="st8l2tu65a" colorInterpolationFilters="auto">
		<feColorMatrix in="SourceGraphic" values="0 0 0 0 0.380392 0 0 0 0 0.219608 0 0 0 0 0.960784 0 0 0 1.000000 0" />
		</filter>
		</defs>
		<g fill="none" fillRule="evenodd"><g transform="translate(-16 -51)">
		<g>
		<path fill="#ffff" fillRule="nonzero" d="M21 0c6.075 0 11 4.925 11 11s-4.925 11-11 11H2c-1.105 0-2-.895-2-2v-9C0 4.925 4.925 0 11 0h10zm-1 9c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2zm-8 0c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z" transform="translate(16 51)" /></g></g></g>
    </svg>
     <br/><span className="searchWrapperContainer_XA3_Text_Hi" id="greetNameXA3">Hi{props.userName}!</span>
     <div className="mobile_hidden"style={{ display:'none'}}>
    <svg  className="searchWrapperContainer_XA3_Text" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" >
        <path d="M40.8 94h285.4c22.533 0 40.8-18.267 40.8-40.8V40.8C367 18.267 348.733 0 326.2 0H0v53.2C0 75.733 18.267 94 40.8 94z" fill="#FFF"/>
        <text fontFamily="XfinityBrown" fontSize="20" fontWeight="bold" letterSpacing="-.2" fill="#3A0092">
                    <tspan x="25.1" y="34.8">I’m Xfinity Assistant. </tspan>
                    <tspan x="25.1" y="62.8">What can I help you with today?</tspan>
                </text>
    </g>
    </svg>
    </div>
      <div className="no_mobile_hidden" style={{ display:'none'}}>
     <svg  className="searchWrapperContainer_XA3_Text_Mobile" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
        <path d="M30 123h187c16.569 0 30-13.431 30-30V30c0-16.569-13.431-30-30-30H0v93c0 16.569 13.431 30 30 30z" fill="#FFF"/>
        <text fontFamily="XfinityBrown" fontSize="20" fontWeight="bold" letterSpacing="-.2" fill="#3A0092">
                    <tspan x="23.1" y="35.8">I’m Xfinity Assistant. </tspan>
                    <tspan x="23.1" y="67.8">What can I help you </tspan>
                    <tspan x="23.1" y="94.8">with today?</tspan>
                </text>
    </g>
    </svg>
    </div>
    </div>


);
